import { Col, Row } from '@guestyci/foundation/esm/Layout';
import TextField from '@guestyci/foundation/TextField';
import useTranslations from '@guestyci/localize/esm/useTranslations/useTranslations';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';
import _extends from '@babel/runtime/helpers/esm/extends';
import { useMediaQuery as useMQ } from 'react-responsive';
import useMediaQuery from '@guestyci/foundation/esm/useMediaQuery/useMediaQuery';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { capitalize } from '@guestyci/foundation/utils/commonUtility';
import moment from 'moment';
import config from 'config';
import Spinner from '@guestyci/foundation/Spinner';
import AppStyle from '../Styles';
import { TRIAL_ALREADY_EXTENDED } from '../constants/errorCodes';
import MarketingLoginButton from '../components/MarketingLoginButton';
import Translations from '../Translations';

const mediaQuery = {
  maxWidth: 'md',
};

const useStyles = createStyles(() => _extends(AppStyle, {}));

const breakpoints = {
  xs: 10,
  sm: 10,
  md: 6,
  lg: 6,
  xl: 6,
  xlg: 6,
};

const ExtendTrialPage = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const email = queryParams.get('email');
  const add = queryParams.get('add');
  const r = queryParams.get('r');

  const [isLoaded, setIsLoaded] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorCode, setErrorCode] = useState(0);
  const [user, setUser] = useState({});
  const [trailInfo, setTrailInfo] = useState({});
  const [newTrailEndDate, setNewTrailEndDate] = useState();

  const baseUrl = config.apiUrl;

  useEffect(() => {
    // eslint-disable-next-line no-undef
    ORIBI.api('setUserEmail', `${email}`);
    axios
      .post(baseUrl.concat('/user-trial/extend'), {
        email,
        days: add,
        promotionCode: r,
      })
      .then((response) => {
        if (response.data.success) {
          setUser(response.data.user);
          setTrailInfo(response.data.trialInfo);
          setNewTrailEndDate(response.data.newTrailEndDate);
          setIsSuccess(true);
          setIsLoaded(true);
        } else {
          setIsLoaded(true);
          setIsSuccess(false);
          setErrorCode(response.data.errorCode);
        }
      });
  }, [add, baseUrl, email, r]);

  const classes = useStyles();

  const isMobileView = useMediaQuery(mediaQuery);

  const translations = {
    titles: [
      {
        id: 'guesty_for_hosts_registration:extend_trial.heading',
        d: 'Hey {name}',
        variables: { name: capitalize(user.firstName) },
      },
    ],
    paragraphs: [
      {
        id: 'guesty_for_hosts_registration:extend_trial.paragraph1',
        d: 'Thank you for your request!',
      },
      {
        id: 'guesty_for_hosts_registration:extend_trial.paragraph2',
        d: 'We have successfully extended your trial for another 14 days. Your trial will terminate on {formattedDate}.',
        variables: {
          formattedDate: moment(new Date(newTrailEndDate)).format('ll'),
        },
      },
      // {
      //   id: 'guesty_for_hosts_registration:extend_trial.paragraph3',
      //   d: 'if you need any further assistance, please feel free to contact us at {email}.',
      //   variables: {email: '<a href="support@guestyforhosts.com"> support@guestyforhosts.com.</a>'}
      // },
      {
        id: 'guesty_for_hosts_registration:extend_trial.paragraph4L1',
        d: 'Best regards,',
      },
      {
        id: 'guesty_for_hosts_registration:extend_trial.paragraph4L2',
        d: 'Guesty For Hosts',
      },
    ],
    errors: [
      {
        id: 'guesty_for_hosts_registration:extend_trial.trail_already_extended',
        d: 'You have already extended your free trial! If you need more time, please feel free to contact us.',
      },
      {
        id: 'guesty_for_hosts_registration:extend_trial.default',
        d: 'Oops! Something went wrong! Help us improve your experience by sending an error report',
      },
    ],
  };
  const [title] = useTranslations(translations.titles, [user.firstName]);
  const [paragraph1, paragraph2, paragraph4L1, paragraph4L2] = useTranslations(
    translations.paragraphs,
    [trailInfo.plusDays, newTrailEndDate]
  );

  const [buttonLabel] = useTranslations(Translations.step3.buttons);
  const [alreadyExtendedError, defaultError] = useTranslations(translations.errors);

  const loginPageURL = config.applicationHost.concat(`/?email=${email}`);

  const isMobile = useMediaQuery(mediaQuery);
  const isSmallHeight = useMQ({ query: '(max-height: 800px)' }) || isMobile;

  return (
    <Row justify={isMobile ? 'center' : 'left'} id="extend-trial-page-container">
      {
        // eslint-disable-next-line
        !isLoaded ? (
          <Row align="center" spacing={4}>
            <Spinner size={50} strokeWidth={4} color="#1B74DA" />
          </Row>
        ) : isSuccess ? (
          <Col
            span={isMobile ? 10 : 12}
            className={[
              classes.pageTextContainer,
              isSmallHeight ? classes.pageTextContainerSmallHeight : '',
            ]}
          >
            <Row
              className={isMobile ? classes.formRowMobile : classes.formRow}
              justify={isMobileView ? 'around' : 'between'}
            >
              <Col id="extend-trial-title">
                <TextField
                  className={[
                    classes.pageHeading,
                    isSmallHeight ? classes.pageHeadingSmallHeight : '',
                  ]}
                  align={isMobileView ? 'center' : 'left'}
                >
                  {title}
                </TextField>
              </Col>
            </Row>
            <Row>
              <Col id="extend-trial-contact-info">
                <TextField
                  className={[
                    classes.pageSubheading,
                    isSmallHeight ? classes.pageSubheadingSmallHeight : '',
                  ]}
                  align={isMobile ? 'center' : 'left'}
                >
                  <p>{paragraph1}</p>
                  <p>{paragraph2}</p>
                  <p>
                    If you need any further assistance, please feel free to contact us at&nbsp;
                    <a href="mailto:support@guestyforhosts.com">support@guestyforhosts.com.</a>
                  </p>
                  <p>
                    {paragraph4L1}
                    <br />
                    {paragraph4L2}
                  </p>
                </TextField>
              </Col>
            </Row>

            <Row justify={isMobileView ? 'center' : 'start'}>
              <Col breakpoints={breakpoints}>
                <MarketingLoginButton successLink={loginPageURL}>
                  {buttonLabel}
                </MarketingLoginButton>
              </Col>
            </Row>
          </Col>
        ) : (
          <TextField
            id="extend-trial-error-message"
            className={[
              classes.pageSubheading,
              isSmallHeight ? classes.pageSubheadingSmallHeight : '',
            ]}
            align={isMobile ? 'center' : 'left'}
          >
            {errorCode === TRIAL_ALREADY_EXTENDED ? alreadyExtendedError : defaultError}
          </TextField>
        )
      }
    </Row>
  );
};

export default ExtendTrialPage;
